import { render } from "./Temporizador.vue?vue&type=template&id=2f69bf84"
import script from "./Temporizador.vue?vue&type=script&lang=ts"
export * from "./Temporizador.vue?vue&type=script&lang=ts"
script.render = render

export default script